import ServiceEndpoints from "../ServiceEndpoints";
import {ErrorCsvRecordForm, ErrorsCsvRecord} from "../../model/ErrorsCsvRecord";
import strings from "../../loc/strings";

const baseUrl = ServiceEndpoints.FetchValidationResults;

export async function fetchValidationResult(form: ErrorCsvRecordForm, encryptedId: string, token: any): Promise<ErrorsCsvRecord[]> {
    const url = `${baseUrl}${encryptedId}`;

    const response = await fetch(url, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
        body: JSON.stringify(form)
    });

    if (!response.ok) {
        if (response.status === 401) {
            throw new Error (strings.messageBarUnauthorizedNCA)
        } else {
            throw new Error('Network response error');
        }
    }

    return response.json();
}

export async function excelExportValidationResults(validationResultsForm: any, encryptedId?: string, userToken?: string): Promise<boolean> {
    const url = `${ServiceEndpoints.ExportToExcelValidationResults}${encryptedId}`;
    return await fetch( url,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(validationResultsForm)
        })
        .then(async (resp) => {
            if(resp.ok) {
                return resp;
            }
            return undefined;
        })
        .then(async (response) => {
            if(response) {
                const blob = await response.blob();
                const contentDisposition = response.headers.get('Content-Disposition');
                const filenameMatch = contentDisposition?.match(/filename\*=UTF-8''(.+)/);
                const filename = filenameMatch ? decodeURIComponent(filenameMatch[1]) : 'download.csv';
                return {blob, filename};
            }
            return undefined;
        })
        .then((blobContainer) => {
            if(blobContainer) {
                const url = window.URL.createObjectURL(new Blob([blobContainer.blob], { type: 'text/csv' }));

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", blobContainer.filename);
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.remove();
                return true;
            }
            return false;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
}
